import { type TDraftState } from './draft';

/** тип устройства */
export type TDevice = 'desktop' | 'mobile';

/** базовый интерфейс виджета */
export interface IAbstractWidget<P> {
    // eslint-disable-next-line id-match
    __mocksource?: {
        fileName: string;
        lineNumber: number;
    };
    /** виджеты вложенные в виджет (чилды) */
    children?: Array<IAbstractWidget<P>>;
    dateFrom?: string;
    dateTo?: string;
    jiraIssue?: string;
    /** имя виджета */
    name: string;
    /** пропсы виджета */
    properties?: P;
    /** id виджета */
    uid?: string;
    /** версия виджета */
    version?: string;
    widgetComment?: string;
    /** флаг виджета отключен/включен */
    widgetDisabled?: boolean;
    /** гео-группы виджета */
    widgetGeo?: string[];
    widgetReused?: boolean;
}

/** свойства виджета */
export type TProcessedProperties = Record<string, unknown>;

/** виджет со свойствами */
export type TProcessedWidget = IAbstractWidget<TProcessedProperties>;

/** Мета-информация */
export type TBaseMeta<S = TDraftState> = {
    meta: {
        /** Комментарий к публичному свойству - используется в пресетах */
        comment?: string | null;
        /** Является ли свойство публичным - используется в пресетах */
        isPublic?: boolean;
        /** Является ли свойство обязательным */
        isRequired?: boolean;
        state?: S;
    };
};

/** Необработанная модель значения свойства виджета с сервера */
export type TWidgetRawPropValue = {
    geo: string[];
    uid: string;
    value: unknown;
};

/** Необработанная модель свойства виджета с сервера */
export type TWidgetRawProp = {
    device: TDevice;
    name: string;
    uid: string;
    values: TWidgetRawPropValue[];
};

/** Значение свойства виджета */
export type TWidgetPropValue = Pick<TWidgetRawPropValue, 'uid'> & {
    meta: Pick<TBaseMeta['meta'], 'state'> & { geo?: TWidgetRawPropValue['geo'] };
    value: string | null | undefined;
};

/** Свойство виджета */
export type TWidgetProp = Pick<TWidgetRawProp, 'uid' | 'name'> &
    TBaseMeta & {
        sortId?: number;
        values: {
            [uid: string]: TWidgetPropValue;
        };
    };

export const WidgetMetaProps = {
    'data-preset-uuid': 'data-preset-uuid',
    'data-widget-name': 'data-widget-name',
    'data-widget-uid': 'data-widget-uid',
    'data-widget-version': 'data-widget-version',
} as const;

type TWidgetMetaPropsType = typeof WidgetMetaProps;

/** Мета данные виджета, добавляются в ASSR-CORE  */
export type TWidgetMetaProps = {
    [key in keyof TWidgetMetaPropsType]?: string;
} & Record<
    Required<keyof Pick<TWidgetMetaPropsType, TWidgetMetaPropsType['data-widget-name']>>,
    string
>;
